/**
 * <s-thumb-gallery> — main image with selectable thumbnails.
 * Thumbnails carry data-src/data-srcset/data-alt/data-match; select(match) lets
 * the customizer show a variant's image. The zoom image mirrors the main image.
 */
class SThumbGallery extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('click', (event) => {
      const thumb = event.target instanceof Element ? event.target.closest('[data-gallery-thumb]') : null;
      if (thumb) this.#show(thumb);
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  select(src) {
    const key = SThumbGallery.key(src);
    if (!key) return;
    const thumb = [...this.querySelectorAll('[data-gallery-thumb]')].find((t) => SThumbGallery.key(t.dataset.match) === key);
    if (thumb) this.#show(thumb);
  }

  static key(src) {
    if (!src) return '';
    return String(src).split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.)/, '');
  }

  #show(thumb) {
    for (const img of this.querySelectorAll('[data-gallery-main], [data-gallery-zoom]')) {
      img.src = thumb.dataset.src;
      img.srcset = thumb.dataset.srcset || '';
      img.alt = thumb.dataset.alt || '';
    }
    for (const t of this.querySelectorAll('[data-gallery-thumb]')) {
      if (t === thumb) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    }
  }
}

if (!customElements.get('s-thumb-gallery')) customElements.define('s-thumb-gallery', SThumbGallery);
